import React from 'react';
import useStoryblok from '~/utils/storyblok-service';
import { graphql } from 'gatsby';
import Layout from '~/components/Layout';
import Seo from '~/components/SEO';
import Image from '~/components/Dynamic/Image';
import Cta from '~/components/ContentFactory/Cta'
import Values from '~/components/ContentFactory/Values'
const AboutPage = ({ data, location, pageContext }) => {
  const story = useStoryblok(data.storyblokEntry, location);
  const content = story?.content;
  return (
    <Layout
      headerColor="black"
      className="text-white bg-black"
      footerColor="black"
      hideFooterCta
      hideSecondaryFooterCta
      locale={pageContext.locale}
    >
      <Seo {...story?.content?.seo} lang={story.lang} pageContext={pageContext} />

      <section className="bg-black pt-48 pb-12 text-white -mt-20">
        <div className="container ">
          <div className="text-center">
            <h1 className="">
              <Image blok={content?.hero} />
              <span className="hidden">{content?.heroText}</span>
            </h1>
            <div className="bg-blue w-full h-4 mt-2 md:h-6 md:mt-4 lg:h-8 lg:mt-6"></div>
          </div>
        </div>
      </section>

      <section className="my-20 md:my-28 mt-14 lg:mt-28">
        <div className="container">
          <div className="grid grid-cols-1 lg:grid-cols-11 lg:gap-16">
            <h2
              className="text-secondary-h1 col-span-6 mb-4"
              dangerouslySetInnerHTML={{ __html: content?.intro[0]?.heading }}
            />
            <div className="col-span-5 order-none mb-8 lg:order-1 lg:mb-0">
              <div
                className="lg:pl-16 mb-20 lg:mb-48 lg:-mt-28 prose"
                dangerouslySetInnerHTML={{ __html: content.intro[0].content }}
              />
              <Image blok={content?.introImages[0]} />
            </div>
            <div className="hidden lg:block col-span-5"></div>
            <div className="col-span-6">
              <div className="mb-12 lg:mb-28">
                <Image blok={content?.introImages[2]} />
              </div>
              <div className="lg:w-4/5 block mx-auto">
                <Image blok={content?.introImages[1]} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Values items={content?.stats} />

      <section className="my-20 md:my-28">
        <div className="container">
          <h2 className="text-secondary-h2 mb-20 text-center">{content?.servicesHeading}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {content?.services?.map((item, i) => (
              <div className="" key={`studioservice${i}`}>
                <div className="border border-white h-full px-8 py-16 hover:bg-black hover:text-white transition-colors duration-300 ease-in-out">
                  <div className="flex flex-col">
                    <h3 className="text-secondary-h3 mb-6">{item.heading}</h3>
                    <p>{item.content}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Cta
        title={content?.ctaHeading}
        linkUrl={`/${content?.ctaButton[0]?.button?.cached_url}`}
        linkText={content?.ctaButton[0]?.title}
        className="text-white"
      />
    </Layout>
  );
};

export default AboutPage;

export const query = graphql`
  query FactoryStudioQuery($id: String!) {
    storyblokEntry(id: { eq: $id }) {
      id
      name
      content
      lang
      slug
      uuid
      full_slug
    }
  }
`;
